import type { AuthState } from '@sigma/client/auth/AuthStore.js';

/** The subset of Cognito's OAuth2 token response the app stores. */
interface CognitoTokenResponse {
    access_token: string;
    id_token: string;
    refresh_token?: string;
}

/**
 * Reads a Cognito OAuth2 token response into an {@link AuthState}. Shared by both patient grants —
 * the authorization-code exchange and the refresh-token renewal — so they can never disagree about
 * how an omitted `refresh_token` is represented: it becomes an explicit `null`, which the renewal
 * flow reads as "Cognito did not rotate the token, keep the one we already have".
 */
export async function parseAuthResponse(response: Response): Promise<AuthState> {
    const tokens = (await response.json()) as CognitoTokenResponse;

    return {
        accessToken: tokens.access_token,
        idToken: tokens.id_token,
        refreshToken: tokens.refresh_token ?? null,
    };
}
